import React from 'react';
import { useFormikContext } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import { DEFAULT_TIMEZONE } from '../../../utils/timezone';

const FormikDatePickerWithTime = ({ field, form, ...props }) => {
    const { setFieldValue } = useFormikContext();

    const handleDateChange = (date) => {
        if (date) {
            // Convert the selected date to Singapore timezone
            const singaporeDate = moment(date).tz(DEFAULT_TIMEZONE).toDate();
            setFieldValue(field.name, singaporeDate);
        } else {
            setFieldValue(field.name, null);
        }
    };

    // Convert field value to proper display format in Singapore timezone
    const getDisplayValue = () => {
        if (!field.value) return null;
        // Ensure we're displaying in Singapore timezone
        return moment(field.value).tz(DEFAULT_TIMEZONE).toDate();
    };

    return (
        <DatePicker
            {...props}
            className='form-control font-b2' // Default to typical styling if props.className not provided, but parent usually provides it
            selected={getDisplayValue()}
            onChange={handleDateChange}
            showTimeSelect
            dateFormat='Pp' // Format for both date and time
            timeZone={DEFAULT_TIMEZONE}
            placeholderText={props.placeholder || "Select date"}
        />
    );
};

export default FormikDatePickerWithTime;
